//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// autopilot-form-room imports
import { IProps } from "./AutopilotFormRoom.d";
import * as s from "./AutopilotFormRoom.styles";
// util
import { ROOM_FLEXIBILITY_VALUES } from "@clockwise/client-commons/src/util/event-tag";
// material-ui
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class AutopilotFormRoomCmpt extends React.Component<IProps> {
  private onAllowRoomsChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.props.onChange(event.target.value === ROOM_FLEXIBILITY_VALUES.FLEXIBLE);
  };

  public render() {
    return (
      <FormControl className={this.props.classes.container} fullWidth>
        <InputLabel shrink htmlFor="cw-room-flex-select">
          Meeting room flexibility
        </InputLabel>
        <Select
          value={
            this.props.defaultAllowSimilarRooms
              ? ROOM_FLEXIBILITY_VALUES.FLEXIBLE
              : ROOM_FLEXIBILITY_VALUES.FIXED
          }
          onChange={this.onAllowRoomsChange}
          name="Meeting room flexibility"
          disabled={this.props.isDisabled}
          MenuProps={{
            style: s.selectStyle.menuStyle,
          }}
          inputProps={{
            name: "Meeting room flexibility",
            id: "cw-room-flex-select",
          }}
          fullWidth
        >
          <MenuItem value={ROOM_FLEXIBILITY_VALUES.FIXED}>Keep original room</MenuItem>
          <MenuItem value={ROOM_FLEXIBILITY_VALUES.FLEXIBLE}>Ok to move to similar room</MenuItem>
        </Select>
      </FormControl>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const AutopilotFormRoom = withStyles(s.styles)(AutopilotFormRoomCmpt);
